import * as log from "loglevel";

import { action, computed, observable, runInAction } from "mobx";
import { Agent } from "../../services/agent";
import { RootStore } from "../root-store";
import { App } from "./app";
import { AppAction } from "./app-action";
import { BaseModel } from "./base-model";

export class ProjectPermission extends BaseModel {
	@observable appId: string;
	@observable app: App;
	@observable projectMemberId: string;

	constructor(data: any){
		super(data);
		this.fromJSON(data);
	}

	fromJSON(data: any){
		super.fromJSON(data);
	}

	@action async loadActions(){
		await RootStore.actionStore.loadPermissionActions(this.id);
	}

	@computed get actions(): AppAction[] {
		return RootStore.actionStore.findByPermissionId(this.id);
	}

	@action async addProjectPermissionAction(actId: string){
		try{
			this.loading = true;
			await Agent.ProjectPermissions.addProjectPermissionAction(this.id, actId);
			runInAction(() => {
				this.errorMessage = null;
			});
		}
		catch(err){
			runInAction(() => {
				this.errorMessage = err.message;
			});
		}
		finally{
			runInAction(() => {
				this.loading = false;
			});
		}
	}

	@action async removeProjectPermissionAction(actId: string){
		try{
			this.loading = true;
			await Agent.ProjectPermissions.removeProjectPermissionAction(this.id, actId);
			runInAction(() => {
				this.errorMessage = null;
			});
		}
		catch(err){
			runInAction(() => {
				this.errorMessage = err.message;
			});
		}
		finally{
			runInAction(() => {
				this.loading = false;
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/stores/models/project-permission.ts